module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-bodymatter element-container-single element-type-chapter element-with-heading",
    attrs: {
      "id": "vol-1-chapter-10"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "vol-1-chapter-10-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-title-is-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("10")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "vol-1-chapter-10-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("W")]), _vm._v("hen Black entered the waiting room, he saw that the only people occupying it were Jennifer and Merryn. It was a depressing place, the furniture comprising a row of blue plastic chairs along one wall and a low squat table with scattered out-of-date "), _c('i', [_vm._v("Interior Design")]), _vm._v(" magazines. A coffee machine was in a corner with a sign stating it was out of order. The lighting was the same strip lighting in the interview room. Bright, glaring. There were no windows, and the place was cold. "), _c('i', [_vm._v("Rooms with no windows,")]), _vm._v(" thought Black – "), _c('i', [_vm._v("the architect should be shot.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Merryn was in a pink and orange onesie, and lying across two seats under a blanket, asleep.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Jennifer rose to her feet.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“My God, Adam. What the hell’s going on? I got a call from Simon…”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Black held her close, smelled the clean soap on her skin, the fragrance of her hair. She didn’t belong in a place like this.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“I’ll tell you back at the house,” he whispered in her ear. “Over a drink.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Jennifer held him tighter. “What happened, Adam?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Shit happened. Unbelievable shit. But it’s okay. It’s all okay.” He held her back a little and attempted a smile. “I guess it’s soggy pasta.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("She began to sob, and he held her again, thinking of the blood moon and her prediction of bad luck, and let the moment drift.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f5d57e5c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vol001chapter010.vue
// module id = 102
// module chunks = 0